/*!
 * Copyright 2016, Amazon.com, Inc. or its affiliates. All Rights Reserved.
 */
